import StatusChip, { statusChipStatus } from "@common/components/statusChip/StatusChip";
import { useTranslation } from "@localization/useTranslation";
import { ProcessingActivityStatus } from "./ProcessingActivities.types";
import { exhaustiveGuard } from "@common/utilities";

export interface ProcessingActivityStatusChipProps {
    status: ProcessingActivityStatus;
}

// Archived reuses the colour contracts, systems and legal entities give their end-of-life state, so the overviews
// read the same. The two Research states sit between draft and active, hence the warm colours, and differ from each
// other because they wait on different people: a submitted draft on the reviewer, a returned one on the researcher.
function ProcessingActivityStatusChip(props: ProcessingActivityStatusChipProps) {
    const { translateStatus } = useTranslation();

    function getChipColor(status: ProcessingActivityStatus): statusChipStatus {
        switch (status) {
            case ProcessingActivityStatus.Active:
                return "green";
            case ProcessingActivityStatus.Draft:
                return "lightgreen";
            case ProcessingActivityStatus.DraftSubmitted:
                return "yellow";
            case ProcessingActivityStatus.AwaitingResearcher:
                return "orange";
            case ProcessingActivityStatus.Archived:
                return "purple";
            case ProcessingActivityStatus.Cancelled:
                return "grey";
            default:
                return exhaustiveGuard(status);
        }
    }

    return <StatusChip value={translateStatus(props.status.toString())} status={getChipColor(props.status)} />;
}

export default ProcessingActivityStatusChip;
